import { alertSlotRecipe } from './alert'
import { dialogSlotRecipe } from './dialog'

export const slotRecipes = {
  dialog: dialogSlotRecipe,
  alert: alertSlotRecipe,
}
